import { Vue } from 'vue-class-component';
import { CampaignAction } from '../api/redeem/redeem';

export default class WithCampaignConstants extends Vue {
  CampaignAction: typeof CampaignAction;
  created() {
    this.CampaignAction = CampaignAction;
  }
}
